import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { ModalTemplate, StartExamWizardContent, StartExamWizardHeader, StartExamWizardButton } from 'components';
import { Button, Image } from 'semantic-ui-react';

import { Map, List, fromJS } from 'immutable';

import classNames from 'classnames/bind';
import styles from './StartExam.css';
const cx = classNames.bind(styles);

const initValue = ({ initType, formatMessage }) => {
  // inforceError
  if (initType === 'inforceError') {
    return fromJS([
      // 2, 3, 4 페이지 다음(실행) 버튼 및 강제 에러 보기에 대한 초기 활성화 검사 flag
      {
        disableNext: false,
        forceViewError: {}
      },
      {
        disableNext: false,
        forceViewError: {}
      },
      {
        disableNext: false,
        forceViewError: {}
      }
    ]);
  } else {
    // fieldInfo
    return fromJS({
      // 필드 라벨
      examReactiveValidator: {
        // redux-form 버그로 인한 임시방편
        label: defineMessages(formatMessage({ id: 'StartExam_3', defaultMessage: '(숨김)' })),
        error: false,
        validation: true,
        validateLabel: false
      },
      examName: {
        label: defineMessages(formatMessage({ id: 'StartExam_4', defaultMessage: '훈련명' })),
        error: false,
        validation: true,
        validateLabel: true
      },
      examStartDate: {
        label: defineMessages(formatMessage({ id: 'StartExam_5', defaultMessage: '시작일자' })),
        error: false,
        validation: true,
        validateLabel: true
      },
      examEndDate: {
        label: defineMessages(formatMessage({ id: 'StartExam_6', defaultMessage: '종료일자' })),
        error: false,
        validation: true,
        validateLabel: true
      },
      isAllTarget: {
        label: defineMessages(
          formatMessage({ id: 'StartExam_17', defaultMessage: '모든 대상자를 지정하여 훈련을 진행합니다.' })
        ),
        error: false,
        validation: true,
        validateLabel: false
      },
      examTargetSelected: {
        label: defineMessages(formatMessage({ id: 'StartExam_9', defaultMessage: '대상자 선택 여부 (숨김)' })),
        error: false,
        validation: true,
        validateLabel: false
      },
      examTargetTag: {
        label: defineMessages(formatMessage({ id: 'StartExam_7', defaultMessage: '대상자 태그' })),
        error: false,
        validateLabel: true
      },
      exceptExamTargetTag: {
        label: defineMessages(formatMessage({ id: 'StartExam_18', defaultMessage: '예외 태그' })),
        error: false,
        validateLabel: true
      },
      examTargetRandomPer: {
        label: defineMessages(formatMessage({ id: 'StartExam_11', defaultMessage: '훈련 대상자 선택 비율' })),
        error: false,
        validateLabel: true
      },
      sendReserveEnable: {
        label: '-',
        error: false,
        validateLabel: true
      },
      sendReservePeriod: {
        label: defineMessages(formatMessage({ id: 'StartExam_12', defaultMessage: '나눔 발송 기간 (일)' })),
        error: false,
        validateLabel: true
      },
      sendReserveHour: {
        label: defineMessages(formatMessage({ id: 'StartExam_13', defaultMessage: '나눔 발송 시간' })),
        error: false,
        validateLabel: true
      },
      examTargetEmail: {
        label: defineMessages(formatMessage({ id: 'StartExam_8', defaultMessage: '대상자 이메일' })),
        error: false,
        validateLabel: true
      },
      // examLicenseCheck: {
      //   label: '라이센스 체크',
      //   error: false,
      //   validateLabel: true
      // },
      examTemplateSelected: {
        label: '훈련 양식 선택 여부',
        error: false,
        validation: true,
        validateLabel: false
      },
      examTemplate: {
        label: defineMessages(formatMessage({ id: 'StartExam_10', defaultMessage: '훈련 양식(템플릿)' })),
        error: false,
        validation: true,
        validateLabel: false
      },
      isAttachScreenView: {
        label: defineMessages(formatMessage({ id: 'StartExam_14', defaultMessage: '악성파일 화면 잠금 일시 활성화' })),
        error: false,
        validation: true,
        validateLabel: false
      },
      attachScreenLock: {
        label: defineMessages(formatMessage({ id: 'StartExam_15', defaultMessage: '악성파일 화면 잠금 일시 지정' })),
        error: false,
        validation: true,
        validateLabel: false
      },
      attachScreenLockDate: {
        label: defineMessages(formatMessage({ id: 'StartExam_16', defaultMessage: '예약 실행 날짜' })),
        error: false,
        validation: true,
        validateLabel: false
      },
      attachScreenLockHour: {
        label: defineMessages(formatMessage({ id: 'StartExamWizardContent_32', defaultMessage: '시간' })),
        error: false,
        validation: true,
        validateLabel: false
      },
      attachScreenLockMin: {
        label: defineMessages(formatMessage({ id: 'StartExamWizardContent_33', defaultMessage: '분' })),
        error: false,
        validation: true,
        validateLabel: false
      },
      useExamSystemUrl: {
        label: defineMessages(formatMessage({ id: 'StartExamWizardContent_122', defaultMessage: '훈련 URL 사용' })),
        error: false,
        validation: true,
        validateLabel: false
      },
      examSystemUrl: {
        label: defineMessages(formatMessage({ id: 'StartExamWizardContent_123', defaultMessage: '훈련 URL 선택' })),
        error: false,
        validation: true,
        validateLabel: false
      }
    });
  }
};

class StartExam extends Component {
  constructor(props) {
    super(props);

    // 국제화 처리
    const { formatMessage } = this.props.intl;

    this.fieldInfo = initValue({ initType: 'fieldInfo', formatMessage }).toJS();
    this.state = {
      inforceError: initValue({ initType: 'inforceError', formatMessage }).toJS(),
      validationInfo: null
    };
  }

  componentWillReceiveProps(nextProps) {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { step, visible } = this.props;
    const { invalid, formStore, visible: nextVisible } = nextProps;
    let updateState = { validationInfo: null };

    if (step === 2 || step === 3 || step === 4) {
      updateState = this.getValidatieResult(invalid, formStore);
    }

    if (visible !== nextVisible && !nextVisible) {
      // 모달이 닫히면 각종 상태값을 초기화한다.
      this.fieldInfo = initValue({ initType: 'fieldInfo', formatMessage }).toJS();
      updateState.inforceError = initValue({ initType: 'inforceError', formatMessage }).toJS();
    }

    this.setState(updateState);
  }

  getValidatieResult = (invalid, formStore, inforceErrorState) => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { step, tagData, examPrepareData } = this.props;
    const { fieldInfo } = this;

    if (typeof inforceErrorState === 'undefined') {
      inforceErrorState = this.state.inforceError;
    }
    const updateState = { validationInfo: null };
    const filedStatus = { all: 0, error: 0 };

    // 공통코드 후보
    // 입력값 검증
    if (formStore && formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          fieldInfo[field].error = false;
          if (formStore.registeredFields[field].count > 0 && fieldInfo[field].validation) {
            filedStatus.all += 1;
          }
        }
      }

      const validationInfo = null;
      if (invalid) {
        const validationResult = [];
        const errorType = ['syncErrors', 'syncWarnings', 'asyncErrors', 'asyncWarnings'];

        for (let i = 0, l = errorType.length; i < l; i++) {
          if (formStore[errorType[i]]) {
            for (const field in formStore[errorType[i]]) {
              if (formStore[errorType[i]].hasOwnProperty(field)) {
                if (
                  (inforceErrorState[step - 2].forceViewError[field] ||
                    (formStore.fields && formStore.fields[field] && formStore.fields[field].touched)) &&
                  formStore.registeredFields[field] &&
                  formStore.registeredFields[field].count === 1
                ) {
                  filedStatus.error += 1;
                  fieldInfo[field].error = true;
                  validationResult.push(
                    (fieldInfo[field].validateLabel && fieldInfo[field].label ? fieldInfo[field].label + ': ' : '') +
                    formStore[errorType[i]][field]
                  );
                }
              }
            }
          }
        }

        if (validationResult.length > 0) {
          // validationInfo = (
          //   <div className={cx('error-info', 'step' + step)}>
          //     <Message error>
          //       <Message.Header>
          //         <Icon name="exclamation circle" />
          //         {defineMessages(formatMessage({ id: 'StartExam_2', defaultMessage: '입력값을 확인해 주세요' }))}
          //       </Message.Header>
          //       <Message.List items={validationResult} />
          //     </Message>
          //   </div>
          // );
          // updateState.validationInfo = validationInfo;

          // 에러가 보여진 경우에는 disableNext: ture 처리하여 invalid 에 의해 버튼 활성화가 되도록 한다.
          if (!inforceErrorState[step - 2].disableNext && filedStatus.all === filedStatus.error) {
            inforceErrorState[step - 2].disableNext = true;
            updateState.inforceError = inforceErrorState;
          }
        }
      }
    }

    return updateState;
  };

  preCheckGoNext = () => {
    const { step, invalid, formStore, handleNextStep, markFieldValidate, examPrepareData } = this.props;
    const { isAllTarget, examTargetTag } = formStore && formStore.values;
    const step3Valid = step === 3 && (examPrepareData.targetCount < 1 || (
      (isAllTarget === 0 || isAllTarget === undefined) && (examPrepareData.targetCount < 1 || (!examTargetTag))
    ))

    if (invalid || step3Valid) {
      // invalid 한 상태로 버튼이 눌러진 경우로 최초 필드 검증을 한번도 타지 않은 상태
      const inforceErrorState = this.state.inforceError;
      inforceErrorState[step - 2].disableNext = true;

      markFieldValidate();

      // 에러를 보여주게끔 forceViewError 를 설정한다.
      if (formStore && formStore.registeredFields) {
        for (const field in formStore.registeredFields) {
          if (formStore.registeredFields.hasOwnProperty(field)) {
            if (formStore.registeredFields[field].count > 0) {
              inforceErrorState[step - 2].forceViewError[field] = true;
            }
          }
        }
      }

      let updateState = {};
      updateState = this.getValidatieResult(invalid, formStore, inforceErrorState);
      updateState.inforceError = inforceErrorState;

      this.setState(updateState);
    } else {
      handleNextStep();
    }
  };

  navigatePage = link => {
    const { handleOnToggleModal, handleNavigatePage } = this.props;

    handleOnToggleModal();
    handleNavigatePage(link);
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { inforceError, validationInfo } = this.state;
    const {
      step,
      loading,
      visible,
      examFail,
      licenseResult,
      initExamLicense,
      formStore,
      invalid,
      handleOnOpenModal,
      handleOnToggleModal,
      handlePrevStep,
      examPrepareData,
      initTargetTags,
      initTemplates,
      tagData,
      templateData,
      examResultData,
      moveExamResult,
      examSystemUrl
    } = this.props;
    const { fieldInfo, preCheckGoNext, navigatePage } = this;

    let step3Invalid = false;
    if (formStore && formStore.values) {
      const { isAllTarget, examTargetTag } = formStore && formStore.values;
      step3Invalid = step === 3 && (examPrepareData.targetCount < 1 || (
        (isAllTarget === 0 || isAllTarget === undefined) && (examPrepareData.targetCount < 1 || (!examTargetTag))
      ))
    }

    return (
      <div className={cx('bt-startExam-area')}>
        <ModalTemplate
          size="small"
          dimmer
          closeOnEscape={false}
          closeOnDimmerClick={false}
          closeOnDocumentClick={false}
          className={cx('startExam-modal')}
          trigger={
            <Button className={cx('bt-startExam')} onClick={handleOnToggleModal}>
              {defineMessages(formatMessage({ id: 'StartExam_1', defaultMessage: '훈련 실시' }))}
            </Button>
          }
          closeIcon={<Image src="/img/common/close_black.png" className={cx('bt-startExam-close icon')} />}
          onOpen={handleOnOpenModal}
          onToggleModal={handleOnToggleModal}
          visible={visible}
          header={<StartExamWizardHeader step={step} examFail={examFail} examResultData={examResultData} />}
          buttons={
            <StartExamWizardButton
              step={step}
              loading={loading}
              invalid={invalid || step3Invalid}
              disableNext={inforceError[step - 2] ? inforceError[step - 2].disableNext || false : false}
              handleGoPrevious={handlePrevStep}
              handleGoNext={preCheckGoNext}
              handleOnToggleModal={handleOnToggleModal}
              stepCount={5}
            />
          }>
          <StartExamWizardContent
            step={step}
            loading={loading}
            examFail={examFail}
            licenseResult={licenseResult}
            initExamLicense={initExamLicense}
            formStore={formStore}
            invalid={invalid || step3Invalid}
            forceViewError={inforceError[step - 2] ? inforceError[step - 2].forceViewError : {} || {}}
            examPrepareData={examPrepareData}
            initTargetTags={initTargetTags}
            tagData={tagData}
            initTemplates={initTemplates}
            templateData={templateData}
            examResultData={examResultData}
            validationInfo={validationInfo}
            fieldInfo={fieldInfo}
            navigatePage={navigatePage}
            moveExamResult={moveExamResult}
            examSystemUrl={examSystemUrl}
          />
        </ModalTemplate>
      </div>
    );
  }
}

StartExam.propTypes = {
  step: PropTypes.number,
  loading: PropTypes.bool
};
StartExam.defaultProps = {
  step: 1,
  loading: true
};

export default injectIntl(StartExam);



// WEBPACK FOOTER //
// ./src/script/components/exam-start/StartExam.js